import React, { useCallback, useState } from 'react';

import './movements.scss';
import moment from 'moment';
import { Button } from 'src/components/Button/Button';
import { AssignmentStatus, EldMovement } from 'src/common/types';
import { claimMovements, setAllMovementsClaimed } from '../store/movementStore';
import { useDispatch, useSelector } from 'react-redux';
import { getDriverInfo } from 'src/features/profile/store';

interface ClaimMovementProps {
  movements: EldMovement[];
  day: string;
}

export const ClaimAllMovements: React.FC<ClaimMovementProps> = ({ movements, day }) => {
  const dispatch = useDispatch();
  const driverInfo = useSelector(getDriverInfo);
  const [disabled, setDisabled] = useState(false);

  const getUnclaimedMovementIds = useCallback(
    () => movements.filter(m => !m.claimed).map(m => m.movementId),
    [movements],
  );

  const handleClaimAll = () => {
    dispatch(
      claimMovements({
        employeeId: driverInfo.employeeId,
        movements: getUnclaimedMovementIds(),
      }),
    );

    dispatch(
      setAllMovementsClaimed({
        status: AssignmentStatus.UNASSIGNED,
        movementIds: getUnclaimedMovementIds(),
      }),
    );
    setDisabled(true);
  };
  return (
    <div className="movements-claim-all">
      <div className="claim-all-time">{moment(day).format('dddd MMMM D, YYYY')}</div>
      <div style={{ display: 'flex', justifyContent: 'right', gap: '0.3em' }}>
        <Button
          className="movement-button-claim-all "
          title="Claim all"
          onClick={handleClaimAll}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
